import {Order} from "@/components/OrdersToMergeInvoice/ValueObject/Order";

export default class DefaultState {
  loading = false;
  customers: Order[][] = [];
  invoicesConverting: string[] = [];
}
